
var animationFlagPC = false;
function showHideText(e, id, allCount) {
    e.preventDefault();

    if (animationFlagPC) {
        return;
    }
    animationFlagPC = true;

    // 保存当前操作的ID，用于在回调中判断
    const currentId = id;
    const queTxtDivList = document.querySelectorAll('.titleAndIconDiv .smallHeadTitle')

    queTxtDivList.forEach((clickItem, index) => {
        clickItem.style.color = '#000'
    })

    if (e.target.className == 'smallHeadTitle') {
        e.target.style.color = '#00ade5'
    } else {
        const item = e.target;
        const targetBrother = item.parentElement.parentElement.querySelector('.smallHeadTitle');
        targetBrother.style.color = '#00ade5'
    }

    // 先处理图标状态和内容切换（针对当前点击的项）
    const $currentContent = $("#hidden-content-" + id);
    const $currentIcon = $("#icon-" + id);

    if ($currentContent.css("display") === "none") {
        $currentIcon.css("background-image", "url('{{ 'MinusIcon.svg' | asset_url }}')");
    } else {
        $currentIcon.css("background-image", "url('{{ 'AddMajor.svg' | asset_url }}')");
    }

    // 切换当前项
    $currentContent.slideToggle();

    // 收起其他所有项（只收起，不展开）
    for (let i = 1; i <= allCount; i++) {
        if (i != currentId) {
            const $otherContent = $("#hidden-content-" + i);
            const $otherIcon = $("#icon-" + i);

            // 只有当其他项是展开状态时才收起
            if ($otherContent.css("display") !== "none") {
                $otherContent.slideUp();
                $otherIcon.css("background-image", "url('{{ 'AddMajor.svg' | asset_url }}')");
            }
        }
    }

    setTimeout(function () {
        animationFlagPC = false;
    }, 500);
}

// function playYoutubeVideo(e, url) {
//     e.preventDefault()
//     var videoHtml = '<iframe width="100%" height="100%" src="' + url + '" class="youtube-player youtubeVideo" frameborder="0"></iframe>';

//     $(".videoIframe").prepend(videoHtml);
//     $(".show-video").show();
// }

// $(".video-close").click(function () {
//     $(".show-video").hide();
//     $(".youtubeVideo").remove();
// })

var animationFlagMobile = false;
function showHideTextMobile(e, id, allCount) {
    e.preventDefault();

    if (animationFlagMobile) {
        return;
    }
    animationFlagMobile = true;

    // 保存当前操作的ID，用于在回调中判断
    const currentId = id;
    const queTxtDivList = document.querySelectorAll('.smallHeadText-mobile .smallHeadTitle-mobile')

    queTxtDivList.forEach((clickItem, index) => {
        clickItem.style.color = '#000'
    })

    if (e.target.className == 'smallHeadTitle-mobile') {
        e.target.style.color = '#00ade5'
    } else {
        const item = e.target;
        const targetBrother = item.parentElement.parentElement.querySelector('.smallHeadTitle-mobile');
        targetBrother.style.color = '#00ade5'
    }

    // 先处理图标状态和内容切换（针对当前点击的项）
    const $currentContent = $("#hidden-content-mobile-" + id);
    const $currentIcon = $("#icon-mobile-" + id);

    if ($currentContent.css("display") === "none") {
        $currentIcon.css("background-image", "url('{{ 'MinusIcon.svg' | asset_url }}')");
    } else {
        $currentIcon.css("background-image", "url('{{ 'AddMajor.svg' | asset_url }}')");
    }

    // 切换当前项
    $currentContent.slideToggle();

    // 收起其他所有项（只收起，不展开）
    for (let i = 1; i <= allCount; i++) {
        if (i != currentId) {
            const $otherContent = $("#hidden-content-mobile-" + i);
            const $otherIcon = $("#icon-mobile-" + i);

            // 只有当其他项是展开状态时才收起
            if ($otherContent.css("display") !== "none") {
                $otherContent.slideUp();
                $otherIcon.css("background-image", "url('{{ 'AddMajor.svg' | asset_url }}')");
            }
        }
    }

    setTimeout(function () {
        animationFlagMobile = false;
    }, 500);
}
